module.exports = __webpack_public_path__ + "static/img/tips.c293209.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/curtains/tips.png
// module id = u+/b
// module chunks = 1